import React from 'react';
import './FourFourFourAI.css';

function FourFourFourAI() {
  return (
    <div className="four-ai-container">
      <div className="four-ai-content">
        <h1 className="app-name">444-ai</h1>
        <p className="tagline">Your Personal Mental Wellness Companion</p>
        
        <div className="intro-section">
          <p className="intro-text">
            444-ai is an intelligent mental wellness app designed to support your emotional well-being 
            through personalized AI-powered conversations. Whether you're seeking clarity, managing stress, 
            or simply need someone to talk to, 444-ai is here for you—anytime, anywhere.
          </p>
          
          <p className="intro-text">
            Built with empathy and powered by advanced AI, our app creates a safe, judgment-free space 
            where you can express yourself freely. Experience mental wellness support that adapts to your 
            unique needs, helping you navigate life's challenges with confidence and calm.
          </p>
        </div>

        <div className="features-brief">
          <div className="feature-item">
            <span className="emoji">🧠</span>
            <h3>Intelligent Support</h3>
            <p>AI that understands and responds to your emotional needs</p>
          </div>
          
          <div className="feature-item">
            <span className="emoji">🔒</span>
            <h3>Private & Secure</h3>
            <p>Your conversations are confidential and protected</p>
          </div>
          
          <div className="feature-item">
            <span className="emoji">⏰</span>
            <h3>24/7 Available</h3>
            <p>Support whenever you need it, day or night</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FourFourFourAI;
